enum ECompensationType {
  Salary = 0,
  Hourly = 1,
}

export default ECompensationType;
